import {ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
    selector: 'db-api-unavailable',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './api-unavailable.component.html',
    styleUrls: ['./api-unavailable.component.scss'],
    standalone: false
})
export class ApiUnavailableComponent implements OnInit {

  @Output() readonly onResize: EventEmitter<[number, number]> = new EventEmitter<[number, number]>();
  @Output() readonly onClose: EventEmitter<void> = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
    this._resize();
  }

  private _resize(): void {
    this.onResize.emit([164, 500]);
  }

  public _redirectToHC(): void {
    window.open( "https://help.10web.io/hc/en-us/articles/6549143350034-Troubleshooting-the-10Web-Booster", "_blank", "noopener");
    this.onClose.emit();
  }
}
